// extracted by mini-css-extract-plugin
export default {"filters-box":"activityLogFilters_filters-box__A-WDn"};